module.exports = __webpack_public_path__ + "static/FRANCESCA_CAVALCHINO-9bfc0f71ae15f54ff6e39d756de5af8e.jpg";